export const parseReportResourceName = (name: string): string => {
  const matches = name.match(/^exploreReports\/(.*)+$/)
  if (!matches) {
    return ""
  }
  return matches[1]
}

export const toReportResourceName = (reportId: string): string => {
  return `exploreReports/${reportId}`
}
